import { forwardRef, type Ref, type SVGProps } from "react";

import parachuteGiftImage from "./assets/parachute-gift.png";

function SvgParachuteGift(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 176 120"
      fill="none"
      {...props}
    >
      <image
        href={parachuteGiftImage}
        x={46.5}
        y={14}
        width={83}
        height={92}
        preserveAspectRatio="none"
      />
    </svg>
  );
}

const ParachuteGift = forwardRef(SvgParachuteGift);

export default ParachuteGift;
